import React, { FC } from 'react';

import Organization from 'entities/organization/model';

interface NonprofitLinkProps {
  nonprofit: Organization | { id: string; name: string };
  style?: object;
}

const NonprofitLink: FC<NonprofitLinkProps> = ({ nonprofit, style }) => (
  // eslint-disable-next-line react/jsx-no-target-blank
  <a
    href={`/organizations/${nonprofit.id}`}
    className="hoverable"
    style={style}
    onClick={(e) => e.stopPropagation()}
    target="_blank"
  >
    {nonprofit.name}
  </a>
);

export default NonprofitLink;
